<form class="m-1">
    <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Filiale :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Filiale" autocomplete="off"
            [(ngModel)]="itemGarant.filiale_libelle" name="filiale_libelle" autocomplete="off" type="text"
            >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Code:
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Code"
            autocomplete="off" [(ngModel)]="itemGarant.code" name="code" autocomplete="off"
            type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Codification:
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Codification" autocomplete="off"
            [(ngModel)]="itemGarant.codification" name="codification" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Libellé :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Libellé" autocomplete="off"
            [(ngModel)]="itemGarant.libelle" name="libelle" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Type garant :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Type garant" autocomplete="off"
            [(ngModel)]="itemGarant.type_garant_libelle" name="type_garant_libelle" autocomplete="off" type="text"
            >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Email :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Email" autocomplete="off"
                [(ngModel)]="itemGarant.email" name="email" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Fax :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Fax" autocomplete="off"
                [(ngModel)]="itemGarant.fax" name="fax" autocomplete="off" type="text" mask="00-00-00-00-00" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Adresse :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Adresse" autocomplete="off"
                [(ngModel)]="itemGarant.adresse" name="adresse" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Boite postale :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Boite postale" autocomplete="off"
                [(ngModel)]="itemGarant.boite_postale" name="boite_postale" autocomplete="off" type="text" />
        </div>
       
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Numéro compte bancaire :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Numéro compte bancaire" autocomplete="off"
                [(ngModel)]="itemGarant.numero_compte_bancaire" name="numero_compte_bancaire" autocomplete="off" type="text" />
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Numéro compte tp :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Numéro compte tp" autocomplete="off"
                [(ngModel)]="itemGarant.numero_compte_tiers_payant" name="numero_compte_tiers_payant" autocomplete="off" type="text" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Numéro compte rd :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Numéro compte rd" autocomplete="off"
                [(ngModel)]="itemGarant.numero_compte_rd" name="numero_compte_rd" autocomplete="off" type="text" />
        </div>
        
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Responsable :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Responsable" autocomplete="off"
                [(ngModel)]="itemGarant.responsable" name="responsable" autocomplete="off" type="text"
                >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Email responsable :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Email responsable" autocomplete="off"
                [(ngModel)]="itemGarant.email_responsable" name="email_responsable" autocomplete="off" type="text"
                >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Fax responsable :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Fax responsable" autocomplete="off"
                [(ngModel)]="itemGarant.fax_responsable" name="fax_responsable" autocomplete="off" type="text"
                mask="00-00-00-00-00">
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Boite postale responsable :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Boite postale responsable" autocomplete="off"
                [(ngModel)]="itemGarant.boite_postale_responsable" name="boite_postale_responsable" autocomplete="off" type="text"
                >
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Taux commission sinistre :
                
            </label>
            <input disabled  mask="separator" class="form-control custom-input" placeholder="Taux commission sinistre" autocomplete="off"
                [(ngModel)]="itemGarant.taux_commission_sinistre" name="taux_commission_sinistre" autocomplete="off" type="text" mask="separator" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Forfait commission sinistre :
                
            </label>
            <input disabled mask="separator" class="form-control custom-input" placeholder="Forfait commission sinsitre" autocomplete="off"
                [(ngModel)]="itemGarant.forfait_commission_sinistre" name="forfait_commission_sinistre" autocomplete="off" type="text" mask="separator" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Taux commission prime :
                
            </label>
            <input disabled mask="separator" class="form-control custom-input" placeholder="Taux commission prime" autocomplete="off"
                [(ngModel)]="itemGarant.taux_commission_prime" name="taux_commission_prime" autocomplete="off" type="text" mask="separator" />
        </div>
        
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Forfait commission prime :
                
            </label>
            <input disabled mask="separator" class="form-control custom-input" placeholder="Forfait commission prime" autocomplete="off"
                [(ngModel)]="itemGarant.forfait_commission_prime" name="forfait_commission_prime" autocomplete="off" type="text" mask="separator" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Tva (%) :
                
            </label>
            <input disabled mask="separator" class="form-control custom-input" placeholder="Taux tva" autocomplete="off"
                [(ngModel)]="itemGarant.tva" name="tva" autocomplete="off" type="text" mask="separator" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Type remboursement :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Type remboursement" autocomplete="off"
            [(ngModel)]="itemGarant.type_remboursement_libelle" name="type_remboursement_libelle" autocomplete="off" type="text"
            >
        </div>
       
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Mode règlement :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Mode règlement" autocomplete="off"
            [(ngModel)]="itemGarant.mode_reglement_libelle" name="mode_reglement_libelle" autocomplete="off" type="text"
            >
        </div>
        

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Seuil alerte consommation (%) :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Seuil alerte conso" autocomplete="off"
                [(ngModel)]="itemGarant.seuil_alerte_conso" name="seuil_alerte_conso" autocomplete="off"
                type="text" mask="separator" />
        </div>

        

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Seuil suspension tiers payant (%) :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Seuil suspension tp" autocomplete="off"
                [(ngModel)]="itemGarant.seuil_suspension_tiers_payant" name="seuil_suspension_tiers_payant"
                autocomplete="off" type="text" mask="separator" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Taux ristourne (%) :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Taux ristourne" autocomplete="off"
                [(ngModel)]="itemGarant.taux_ristourne" name="taux_ristourne"
                autocomplete="off" type="text" mask="separator" />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Taux redressement:
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Taux redressement" autocomplete="off"
                [(ngModel)]="itemGarant.taux_redressement" name="taux_redressement"
                autocomplete="off" type="text" mask="separator" />
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>A qui rembourser? :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="A qui rembourser" autocomplete="off"
            [(ngModel)]="itemGarant.assure_remboursement" name="assure_remboursement" autocomplete="off" type="text"
            >
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Mode tarification :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Mode tarification" autocomplete="off"
            [(ngModel)]="itemGarant.mode_tarification_libelle" name="mode_tarification_libelle" autocomplete="off" type="text"
            >
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Mode reconduction :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Mode reconduction" autocomplete="off"
            [(ngModel)]="itemGarant.mode_reconduction_libelle" name="mode_reconduction_libelle" autocomplete="off" type="text"
            >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Mode fractionnement :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Mode fractionnement" autocomplete="off"
            [(ngModel)]="itemGarant.mode_fractionnement_libelle" name="mode_fractionnement_libelle" autocomplete="off" type="text"
            >
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Tarif appliqué :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Tarif appliqué" autocomplete="off"
            [(ngModel)]="itemGarant.tarif_libelle" name="tarif_libelle" autocomplete="off" type="text"
            >
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label (click)="openModalReseau()"  [ngClass]="{'isSelectedItem':itemGarant.reseau_de_soin_id}">Réseau de soin :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Réseau de soin" autocomplete="off"
            [(ngModel)]="itemGarant.reseau_de_soin_libelle" name="reseau_de_soin_libelle" autocomplete="off" type="text"
            >
        </div>



        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
            <label>Statut :
                
            </label>
            <input disabled class="form-control custom-input" placeholder="Statut" autocomplete="off"
            [(ngModel)]="itemGarant.statut_libelle" name="statut_libelle" autocomplete="off" type="text"
            >
        </div>
        
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <label>Image :
            </label>
            
        </div>

        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
            <input disabled [(ngModel)]="itemGarant.is_prorata_prime"
                                id="is_prorata_prime" name="is_prorata_prime"
                                autocomplete="off" type="checkbox" />
                            <label for="is_prorata_prime">Prorata prime?
                            </label>
        </div>


    </div>
</form>